import { useState } from 'react'
import {
  AleloButton,
  AleloError,
  AleloInput,
  AleloLayout,
  AleloPasswordInput,
} from '@/components/AleloLayout'
import styles from '@/components/AleloLayout.module.css'
import {
  RangoAlert,
  RangoCheckbox,
  RangoFlag,
  RangoInputCode,
  RangoLink,
  RangoModal,
} from '@/components/rango'

/**
 * Galeria de componentes (B2 + B3) — `?screen=components-preview`.
 * Serve para o dono da task testar os componentes isoladamente e anexar
 * screenshot; não é uma tela do Universal Login.
 */
export default function ComponentsPreviewScreen() {
  const [code, setCode] = useState('')
  const [checked, setChecked] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  return (
    <AleloLayout>
      <h1 className={styles.title}>Componentes Rango DS</h1>
      <p className={styles.subtitle}>
        Galeria local dos componentes base — não faz parte do fluxo de login.
      </p>

      <section className={styles.stack} aria-label="Botões">
        <AleloButton>Continuar</AleloButton>
        <AleloButton variant="secondary">Continuar sem organização</AleloButton>
        <AleloButton loading>Entrar</AleloButton>
        <AleloButton disabled>Entrar</AleloButton>
        <RangoLink onClick={() => setModalOpen(true)}>Abrir modal</RangoLink>
        {/* Com href o Link vira <a> (papel de link); sem href, botão. */}
        <RangoLink href="#feedback">Ver mensagens de feedback</RangoLink>
      </section>

      <section className={styles.stack} aria-label="Campos" style={{ marginTop: 24 }}>
        <AleloInput
          label="CPF"
          placeholder="000.000.000-00"
          supportText="Digite os 11 dígitos do seu CPF."
        />
        <AleloInput label="CPF" placeholder="000.000.000-00" error="Informe um CPF válido." />
        <AleloPasswordInput
          label="Senha"
          placeholder="Digite sua senha"
          showLabel="Mostrar senha"
          hideLabel="Ocultar senha"
        />
        <RangoInputCode
          label="Código"
          value={code}
          onChange={setCode}
          length={6}
          supportText="Código enviado para o seu e-mail."
        />
        <RangoInputCode
          label="Código"
          value="1234"
          onChange={() => undefined}
          error="Código inválido ou expirado."
        />
        <RangoCheckbox
          label="Lembrar este dispositivo"
          checked={checked}
          onChange={setChecked}
        />
        <AleloError message="Não foi possível continuar. Tente novamente." />
      </section>

      <section
        id="feedback"
        className={styles.stack}
        aria-label="Feedback"
        style={{ marginTop: 24 }}
      >
        {!dismissed ? (
          <RangoAlert
            tone="informative"
            title="Informação"
            onDismiss={() => setDismissed(true)}
          >
            Você pode continuar sem organização.
          </RangoAlert>
        ) : null}
        <RangoFlag tone="warning" title="Atenção">
          O código expira em 10 minutos.
        </RangoFlag>
        <RangoFlag tone="positive">Senha alterada com sucesso.</RangoFlag>
      </section>

      <RangoModal
        open={modalOpen}
        title="Encerrar todas as sessões?"
        footer={
          <>
            <AleloButton variant="secondary" onClick={() => setModalOpen(false)}>
              Cancelar
            </AleloButton>
            <AleloButton onClick={() => setModalOpen(false)}>Encerrar</AleloButton>
          </>
        }
        onClose={() => setModalOpen(false)}
      >
        Você será desconectado de todos os dispositivos.
      </RangoModal>
    </AleloLayout>
  )
}
